
import * as $ from 'jquery';

import { Template } from 'src/integration/api/ui/templates/Template';

export interface IParams {
    baseUrl: string;
    contentRef: string;
    i18n: any;
}

/** A D2L button that contains the Ally icon and the text "Alternative Formats". */
export class D2lAlternativeFormatsTransparentButton extends Template<IParams> {
    protected template = require('./alternativeformatstransparentbutton.handlebars');
    private blueAfIcon = require('src/integration/img/ally-icon-af-download-logo-blue.svg');

    public apply(params: IParams): JQuery<HTMLElement> {
        return $(this.template({ ...params, 'aafIcon': this.blueAfIcon }));
    }
}
